

// import axios from "axios";
// import toast from "react-hot-toast";

// export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
// export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
// export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

// export const DELETE_ATTENDANCE_REQUEST = "DELETE_ATTENDANCE_REQUEST";
// export const DELETE_ATTENDANCE_SUCCESS = "DELETE_ATTENDANCE_SUCCESS";
// export const DELETE_ATTENDANCE_FAILURE = "DELETE_ATTENDANCE_FAILURE";


// const BASE_URL = process.env.REACT_APP_API_BASE_URL;




// export const fetchAttendance = ({
//   page = 1,
//   limit = 10,
//   district = "",
//   municipality = "",
//   fromDate = "",
//   toDate = "",
//   search = "",
//   designation = ""
// } = {}) => {
//   return async (dispatch) => {
//     dispatch({ type: FETCH_ATTENDANCE_REQUEST });
//     const token = localStorage.getItem("token");

//     const queryParams = new URLSearchParams({
//       page,
//       limit,
//       district,
//       municipality,
//       fromDate,
//       toDate,
//       search,
//       designation,
//     }).toString();

//     try {
//       const response = await axios.get(
//         `${BASE_URL}/v1/api/admin/getAllAttendance?${queryParams}`,
//         {
//           headers: { authorization: token },
//         }
//       );

//       dispatch({
//         type: FETCH_ATTENDANCE_SUCCESS,
//         payload: {
//           attendance: response.data.data,
//           pagination: response.data.meta,
//         },
//       });
//     } catch (error) {
//       let message = "Failed to fetch attendance";
//       if (error?.response?.data?.meta?.message) {
//         message = error.response.data.meta.message;
//       } else if (error?.response?.data?.message) {
//         message = error.response.data.message;
//       } else if (error.message) {
//         message = error.message;
//       }

//       dispatch({
//         type: FETCH_ATTENDANCE_FAILURE,
//         payload: message,
//       });
//     }
//   };
// };



// export const deleteAttendance = (id) => {
//   return async (dispatch) => {
//     dispatch({ type: DELETE_ATTENDANCE_REQUEST });
//     const token = localStorage.getItem("token");

//     try {
//       const response = await axios.delete(`${BASE_URL}/v1/api/admin/deleteAttendance/${id}`, {
//         headers: { authorization: token },
//       });

//       dispatch({ type: DELETE_ATTENDANCE_SUCCESS, payload: id });

//       toast.success("Attendance deleted successfully");

//       // Optionally re-fetch the updated list
//       // dispatch(fetchAttendance());

//     } catch (error) {
//       let message = "Failed to delete attendance";
//       if (error?.response?.data?.meta?.message) {
//         message = error.response.data.meta.message;
//       } else if (error?.response?.data?.message) {
//         message = error.response.data.message;
//       } else if (error.message) {
//         message = error.message;
//       }

//       dispatch({
//         type: DELETE_ATTENDANCE_FAILURE,
//         payload: message,
//       });

//       toast.error(message);
//     }
//   };
// };
import axios from "axios";
import toast from "react-hot-toast";

export const FETCH_ATTENDANCE_REQUEST = "FETCH_ATTENDANCE_REQUEST";
export const FETCH_ATTENDANCE_SUCCESS = "FETCH_ATTENDANCE_SUCCESS";
export const FETCH_ATTENDANCE_FAILURE = "FETCH_ATTENDANCE_FAILURE";

export const DELETE_ATTENDANCE_REQUEST = "DELETE_ATTENDANCE_REQUEST";
export const DELETE_ATTENDANCE_SUCCESS = "DELETE_ATTENDANCE_SUCCESS";
export const DELETE_ATTENDANCE_FAILURE = "DELETE_ATTENDANCE_FAILURE";

export const DIRECT_CHECKIN_REQUEST = "DIRECT_CHECKIN_REQUEST";
export const DIRECT_CHECKIN_SUCCESS = "DIRECT_CHECKIN_SUCCESS";
export const DIRECT_CHECKIN_FAILURE = "DIRECT_CHECKIN_FAILURE";

export const DIRECT_CHECKOUT_REQUEST = "DIRECT_CHECKOUT_REQUEST";
export const DIRECT_CHECKOUT_SUCCESS = "DIRECT_CHECKOUT_SUCCESS";
export const DIRECT_CHECKOUT_FAILURE = "DIRECT_CHECKOUT_FAILURE";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;





// In your attendanceActions.js
export const fetchAttendance = ({
  page = 1,
  limit = 10,
  district = "",
  municipality = "",
  fromDate = "",
  toDate = "",
  search = "",
  designation = ""
} = {}) => {
  return async (dispatch) => {
    dispatch({ type: FETCH_ATTENDANCE_REQUEST });
    const token = localStorage.getItem("token");

    const queryParams = new URLSearchParams({
      page,
      limit,
      district,
      municipality,
      fromDate,
      toDate,
      search,
      designation,
    }).toString();

    try {
      const response = await axios.get(
        `${BASE_URL}/v1/api/admin/getAllAttendance?${queryParams}`,
        {
          headers: { authorization: token },
        }
      );

      // Make sure pagination data exists
      const pagination = response.data.meta || {};
      
      dispatch({
        type: FETCH_ATTENDANCE_SUCCESS,
        payload: {
          attendance: response.data.data || [],
          pagination: {
            currentPage: pagination.page || page,
            itemsPerPage: pagination.limit || limit,
            totalRecords: pagination.totalRecords || 0,
            totalPages: pagination.totalPages || 1,
          }
        },
      });
    } catch (error) {
      let message = "Failed to fetch attendance";
      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: FETCH_ATTENDANCE_FAILURE,
        payload: message,
      });
    }
  };
};

export const deleteAttendance = (id) => {
  return async (dispatch) => {
    dispatch({ type: DELETE_ATTENDANCE_REQUEST });
    const token = localStorage.getItem("token");

    try {
      const response = await axios.delete(`${BASE_URL}/v1/api/admin/deleteAttendance/${id}`, {
        headers: { authorization: token },
      });

      dispatch({ type: DELETE_ATTENDANCE_SUCCESS, payload: id });

      toast.success("Attendance deleted successfully");

      // Optionally re-fetch the updated list
      // dispatch(fetchAttendance());

    } catch (error) {
      let message = "Failed to delete attendance";
      if (error?.response?.data?.meta?.message) {
        message = error.response.data.meta.message;
      } else if (error?.response?.data?.message) {
        message = error.response.data.message;
      } else if (error.message) {
        message = error.message;
      }

      dispatch({
        type: DELETE_ATTENDANCE_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};

export const directCheckIn = ({ user_id, check_in, date, check_in_latitude, check_in_longitude }) => {
  return async (dispatch) => {
    dispatch({ type: DIRECT_CHECKIN_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/direct_check_in`,
        { user_id, check_in, date, check_in_latitude, check_in_longitude},
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({
        type: DIRECT_CHECKIN_SUCCESS,
        payload: response.data,
      });

      toast.success(response.data?.meta?.message || "Check-in successful");
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Direct check-in failed";

      dispatch({
        type: DIRECT_CHECKIN_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};


export const directCheckOut = ({ user_id, check_out, date, check_out_latitude, check_out_longitude}) => {
  return async (dispatch) => {
    dispatch({ type: DIRECT_CHECKOUT_REQUEST });

    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        `${BASE_URL}/v1/api/direct_check_out`,
        { user_id, check_out, date, check_out_latitude, check_out_longitude },
        {
          headers: {
            authorization: token,
            "Content-Type": "application/json",
          },
        }
      );

      dispatch({
        type: DIRECT_CHECKOUT_SUCCESS,
        payload: response.data,
      });

      toast.success(response.data?.meta?.message || "Check-out successful");
    } catch (error) {
      const message =
        error?.response?.data?.meta?.message ||
        error?.response?.data?.message ||
        error.message ||
        "Direct check-out failed";

      dispatch({
        type: DIRECT_CHECKOUT_FAILURE,
        payload: message,
      });

      toast.error(message);
    }
  };
};